import { configureStore } from '@reduxjs/toolkit';
import userAllReducer from '../feature/userAllSlice';
import loginReduer from '../feature/loginSlice';

export const store = configureStore({
    reducer: {
        login: loginReduer,
        datauser: userAllReducer
    }
});